'use client';

import { ReactLenis } from 'lenis/react';

/**
 * SmoothScroll Component — Integrates Lenis for high-end scroll feeling.
 */
export function SmoothScroll({ children }) {
    return (
        <ReactLenis root options={{ lerp: 0.1, duration: 1.5, smoothWheel: true }}>
            {children}
        </ReactLenis>
    );
}
